import React from "react";

const Popup = ({ children, setOpenPopup }) => {
	return (
		<div className="popup overlay">
			<div className="popup__box">
				{/* <p className="text-center bold">Terms and conditions*</p> */}
				<div className="close-btn" onClick={() => setOpenPopup(false)}>
					<i className="fa-solid fa-xmark"></i>
				</div>

				{children}
			</div>
		</div>
	);
};

export default Popup;
